/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".info-entry-container[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;flex-flow:row wrap;-webkit-box-pack:start;justify-content:flex-start;-webkit-box-align:start;align-items:flex-start;align-content:flex-start}.info-entry-container[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{margin-right:5px}#height-entry[_ngcontent-%COMP%]   *[_ngcontent-%COMP%]{width:100px}"];
export { styles as styles };
